import { render, staticRenderFns } from "./commandes_enattente.vue?vue&type=template&id=622450a4&"
import script from "./commandes_enattente.vue?vue&type=script&lang=js&"
export * from "./commandes_enattente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports